/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Call
 */
export interface Call {
  /**
   *
   * @type {number}
   * @memberof Call
   */
  callId?: number;
  /**
   *
   * @type {Array<any>}
   * @memberof Call
   */
  callRecordingIds?: Array<any>;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  companyCallReviewShareLink?: string | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  contactKey?: string;
  /**
   *
   * @type {Array<any>}
   * @memberof Call
   */
  csatRecordingUrls?: Array<any>;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  csatScore?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof Call
   */
  csatTranscriptions?: Array<any>;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  customData?: string | null;
  /**
   *
   * @type {number | null}
   * @memberof Call
   */
  dateConnected?: number | null;
  /**
   *
   * @type {number | null}
   * @memberof Call
   */
  dateEnded?: number | null;
  /**
   *
   * @type {number}
   * @memberof Call
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {number | null}
   * @memberof Call
   */
  dateRang?: number | null;
  /**
   *
   * @type {number | null}
   * @memberof Call
   */
  dateStarted?: number | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  direction: CallDirectionEnum;
  /**
   *
   * @type {number | null}
   * @memberof Call
   */
  duration?: number | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  entryPointCallId?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  entryPointCallKey?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  entryPointTargetId?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  entryPointTargetKey?: string;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  externalNumber?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  groupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  id: string;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  internalNumber?: string | null;
  /**
   *
   * @type {boolean | null}
   * @memberof Call
   */
  isTransferred?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  key: string;
  /**
   *
   * @type {Array<any>}
   * @memberof Call
   */
  labels?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  masterCallRefId?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  masterCallRefKey?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  operatorCallId?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  operatorCallKey?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  proxyTargetId?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  proxyTargetKey?: string;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  publicCallReviewShareLink?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof Call
   */
  recordingUrl?: Array<any>;
  /**
   *
   * @type {Array<any>}
   * @memberof Call
   */
  routingBreadcrumps?: Array<any>;
  /**
   *
   * @type {Array<any>}
   * @memberof Call
   */
  screenRecordingUrls?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  state: CallStateEnum;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  targetId?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  targetKey?: string;
  /**
   *
   * @type {number | null}
   * @memberof Call
   */
  totalDuration?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  transcriptionText?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  voicemailLink?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Call
   */
  voicemailRecordingId?: string | null;
  /**
   *
   * @type {boolean | null}
   * @memberof Call
   */
  wasRecorded?: boolean | null;
}

/**
 * @export
 */
export const CallDirectionEnum = {
  Inbound: 'inbound',
  Outbound: 'outbound',
} as const;
export type CallDirectionEnum =
  (typeof CallDirectionEnum)[keyof typeof CallDirectionEnum];

/**
 * @export
 */
export const CallStateEnum = {
  Preanswer: 'preanswer',
  Calling: 'calling',
  Ringing: 'ringing',
  Connected: 'connected',
  Merged: 'merged',
  Hold: 'hold',
  Queued: 'queued',
  Voicemail: 'voicemail',
  Eavesdrop: 'eavesdrop',
  Monitor: 'monitor',
  Barge: 'barge',
  Hangup: 'hangup',
  Blocked: 'blocked',
  Admin: 'admin',
  Parked: 'parked',
  Takeover: 'takeover',
  Postcall: 'postcall',
  Transcription: 'transcription',
  Recording: 'recording',
  Csat: 'csat',
  Dispositions: 'dispositions',
  Missed: 'missed',
  VoicemailUploaded: 'voicemail_uploaded',
  AdminRecording: 'admin_recording',
} as const;
export type CallStateEnum = (typeof CallStateEnum)[keyof typeof CallStateEnum];

/**
 * Check if a given object implements the Call interface.
 */
export function instanceOfCall(value: object): value is Call {
  if (!('direction' in value) || value['direction'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  if (!('state' in value) || value['state'] === undefined) return false;
  return true;
}

export function CallFromJSON(json: any): Call {
  return CallFromJSONTyped(json, false);
}

export function CallFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Call {
  if (json == null) {
    return json;
  }
  return {
    callId: json['call_id'] == null ? undefined : json['call_id'],
    callRecordingIds:
      json['call_recording_ids'] == null
        ? undefined
        : json['call_recording_ids'],
    companyCallReviewShareLink:
      json['company_call_review_share_link'] == null
        ? undefined
        : json['company_call_review_share_link'],
    contactId: json['contact_id'] == null ? undefined : json['contact_id'],
    contactKey: json['contact_key'] == null ? undefined : json['contact_key'],
    csatRecordingUrls:
      json['csat_recording_urls'] == null
        ? undefined
        : json['csat_recording_urls'],
    csatScore: json['csat_score'] == null ? undefined : json['csat_score'],
    csatTranscriptions:
      json['csat_transcriptions'] == null
        ? undefined
        : json['csat_transcriptions'],
    customData: json['custom_data'] == null ? undefined : json['custom_data'],
    dateConnected:
      json['date_connected'] == null ? undefined : json['date_connected'],
    dateEnded: json['date_ended'] == null ? undefined : json['date_ended'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    dateRang: json['date_rang'] == null ? undefined : json['date_rang'],
    dateStarted:
      json['date_started'] == null ? undefined : json['date_started'],
    direction: json['direction'],
    duration: json['duration'] == null ? undefined : json['duration'],
    entryPointCallId:
      json['entry_point_call_id'] == null
        ? undefined
        : json['entry_point_call_id'],
    entryPointCallKey:
      json['entry_point_call_key'] == null
        ? undefined
        : json['entry_point_call_key'],
    entryPointTargetId:
      json['entry_point_target_id'] == null
        ? undefined
        : json['entry_point_target_id'],
    entryPointTargetKey:
      json['entry_point_target_key'] == null
        ? undefined
        : json['entry_point_target_key'],
    externalNumber:
      json['external_number'] == null ? undefined : json['external_number'],
    groupId: json['group_id'] == null ? undefined : json['group_id'],
    id: json['id'],
    internalNumber:
      json['internal_number'] == null ? undefined : json['internal_number'],
    isTransferred:
      json['is_transferred'] == null ? undefined : json['is_transferred'],
    key: json['key'],
    labels: json['labels'] == null ? undefined : json['labels'],
    masterCallRefId:
      json['master_call_ref_id'] == null
        ? undefined
        : json['master_call_ref_id'],
    masterCallRefKey:
      json['master_call_ref_key'] == null
        ? undefined
        : json['master_call_ref_key'],
    operatorCallId:
      json['operator_call_id'] == null ? undefined : json['operator_call_id'],
    operatorCallKey:
      json['operator_call_key'] == null ? undefined : json['operator_call_key'],
    proxyTargetId:
      json['proxy_target_id'] == null ? undefined : json['proxy_target_id'],
    proxyTargetKey:
      json['proxy_target_key'] == null ? undefined : json['proxy_target_key'],
    publicCallReviewShareLink:
      json['public_call_review_share_link'] == null
        ? undefined
        : json['public_call_review_share_link'],
    recordingUrl:
      json['recording_url'] == null ? undefined : json['recording_url'],
    routingBreadcrumps:
      json['routing_breadcrumps'] == null
        ? undefined
        : json['routing_breadcrumps'],
    screenRecordingUrls:
      json['screen_recording_urls'] == null
        ? undefined
        : json['screen_recording_urls'],
    state: json['state'],
    targetId: json['target_id'] == null ? undefined : json['target_id'],
    targetKey: json['target_key'] == null ? undefined : json['target_key'],
    totalDuration:
      json['total_duration'] == null ? undefined : json['total_duration'],
    transcriptionText:
      json['transcription_text'] == null
        ? undefined
        : json['transcription_text'],
    voicemailLink:
      json['voicemail_link'] == null ? undefined : json['voicemail_link'],
    voicemailRecordingId:
      json['voicemail_recording_id'] == null
        ? undefined
        : json['voicemail_recording_id'],
    wasRecorded:
      json['was_recorded'] == null ? undefined : json['was_recorded'],
  };
}

export function CallToJSON(value?: Call | null): any {
  if (value == null) {
    return value;
  }
  return {
    call_id: value['callId'],
    call_recording_ids: value['callRecordingIds'],
    company_call_review_share_link: value['companyCallReviewShareLink'],
    contact_id: value['contactId'],
    contact_key: value['contactKey'],
    csat_recording_urls: value['csatRecordingUrls'],
    csat_score: value['csatScore'],
    csat_transcriptions: value['csatTranscriptions'],
    custom_data: value['customData'],
    date_connected: value['dateConnected'],
    date_ended: value['dateEnded'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    date_rang: value['dateRang'],
    date_started: value['dateStarted'],
    direction: value['direction'],
    duration: value['duration'],
    entry_point_call_id: value['entryPointCallId'],
    entry_point_call_key: value['entryPointCallKey'],
    entry_point_target_id: value['entryPointTargetId'],
    entry_point_target_key: value['entryPointTargetKey'],
    external_number: value['externalNumber'],
    group_id: value['groupId'],
    id: value['id'],
    internal_number: value['internalNumber'],
    is_transferred: value['isTransferred'],
    key: value['key'],
    labels: value['labels'],
    master_call_ref_id: value['masterCallRefId'],
    master_call_ref_key: value['masterCallRefKey'],
    operator_call_id: value['operatorCallId'],
    operator_call_key: value['operatorCallKey'],
    proxy_target_id: value['proxyTargetId'],
    proxy_target_key: value['proxyTargetKey'],
    public_call_review_share_link: value['publicCallReviewShareLink'],
    recording_url: value['recordingUrl'],
    routing_breadcrumps: value['routingBreadcrumps'],
    screen_recording_urls: value['screenRecordingUrls'],
    state: value['state'],
    target_id: value['targetId'],
    target_key: value['targetKey'],
    total_duration: value['totalDuration'],
    transcription_text: value['transcriptionText'],
    voicemail_link: value['voicemailLink'],
    voicemail_recording_id: value['voicemailRecordingId'],
    was_recorded: value['wasRecorded'],
  };
}
